import { getSpecialties } from "../webclients/specialties.client";

export const specialtyApi = {
  getSpecialties: async () => {
    const response = await getSpecialties();
    return response.data;
  },
};

export default specialtyApi;
